import { Group } from '@front-app/services/GroupsApi/GroupModel';
import { sortAlphabeticalDesc, sortNumericDesc } from '@front-app/util/sort';

export function sortGroupByAlphabetical(a: Group, b: Group): number {
	return sortAlphabeticalDesc(a.name, b.name);
}

export function sortGroupByLastVisit(a: Group, b: Group): number {
	return sortNumericDesc(a.lastVisited, b.lastVisited);
}
